import React, {ReactElement} from "react";
import "./LabeledSection.css"

function LabeledSection({icon, label, children, red} : {icon: ReactElement, label: string, children: ReactElement[], red?: boolean}) {
    let className = "labeled-section"
    if (red) {
        className += " red"
    }

    return <fieldset className={className}>
        <legend>
            <div className="labeled-section-icon">{icon}</div>
            <div className="labeled-section-label">{label}</div>
        </legend>
        <div className="labeled-section-content">
            {children}
        </div>
    </fieldset>
}

export default LabeledSection;